<template>
    <div v-if="animationsEnabled" class="vrm-theme-background__animation">
        <rive-animation
            ref="animation"
            class="desktop-only"
            src="/anim/summer_login_desktop.riv"
            alignment="bottomLeft"
            fit="fitWidth"
            :state-machines="['Desktop']"
            :autoplay="true"
            :disable-rive-listeners="isTouchDevice"
            @load="onLoad"
        ></rive-animation>

        <img
            class="mobile-only"
            src="/img/summer/background-login-mobile.svg"
            alt="Summer illustration of a beach"
        />
    </div>

    <div v-else class="vrm-theme-background__fallback">
        <img
            class="mobile-only"
            src="/img/summer/background-login-mobile.svg"
            alt="Summer illustration of a beach"
        />

        <img
            class="desktop-only"
            src="/img/summer/background-login-desktop.svg"
            alt="Summer illustration of a beach"
        />
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import RiveAnimation from '@/vue/components/shared/anim/RiveAnimation';
import ClassWatcher from '@/vue/components/shared/anim/class-watcher';

@Component({
    components: {
        RiveAnimation,
    },
    data: function() {
        return {
            rive: undefined,
            riveJumpTrigger: undefined,
            isLoaded: false,
        };
    },
})
@AngularDirective('vrm-summer-login-animation')
export default class VrmSummerLoginAnimation extends Vue {
    @ngInject()
    AppearanceService;

    @ngInject()
    vrmThemes;

    isLightMode = null;

    watcher = null;

    created() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    mounted() {
        if (this.themeFromConfig != null) {
            // Only listen for dark mode changes if there is an active theme at the moment.
            this.watcher = new ClassWatcher(
                document.documentElement,
                'dark',
                this.onModeChanged,
                this.onModeChanged,
            );

            this.isLightMode = !document.documentElement.classList.contains('dark');
        }

        window.addEventListener('resize', this.onResize);
    }

    onModeChanged() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    /**
     * Resize the Rive drawing surface if the window size changes.
     *
     * @param e
     */
    // eslint-disable-next-line no-unused-vars
    onResize(e) {
        if (this.rive) {
            this.rive.resizeDrawingSurfaceToCanvas();
        }
    }

    /**
     * Called before the component has been destroyed.
     *
     * Removes the event listeners.
     */
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        if (this.rive) {
            this.rive.cleanup();
        }
    }

    /**
     * Called when the Rive animation is loaded.
     *
     * Initialize any listeners needed for the animation.
     *
     * @param e
     */
    onLoad(e) {
        // Resize canvas to improve resolution.
        if (e.rive) {
            this.rive = e.rive;
            this.rive.play();
        }

        this.isLoaded = true;

        /**
         * Emitted when the animation is loaded.
         *
         * @event load
         * @type {Event}
         */
        this.$emit('load', e);
    }

    /**
     * Check if device is a touch device.
     *
     * @returns {boolean}
     */
    get isTouchDevice() {
        return (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        );
    }

    /**
     * Check if animations are enabled in the config.
     *
     * @returns {*|boolean}
     */
    get animationsEnabled() {
        return this.AppearanceService.isSummerThemeAnimationsActive();
    }
}
</script>
